import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import BEMHelper from 'react-bem-helper';
import { getDataTestAttribute } from '../../../helpers/dataTestAttributeHelper';
import './APLabelWithText.css';
var baseClasses = new BEMHelper({
  name: 'ap-label-with-text',
  outputIsString: true
});
var LabelWithText = function LabelWithText(props) {
  var label = props.label,
    text = props.text,
    customClass = props.customClass,
    classModifiers = props.classModifiers;
  var customClasses = new BEMHelper({
    name: customClass,
    outputIsString: true
  });
  return React.createElement('div', {
    className: classnames(baseClasses(), customClasses('lwt-container', classModifiers))
  }, React.createElement('label', {
    className: classnames('ap--label', baseClasses('label'), customClasses('lwt-label', classModifiers))
  }, label), React.createElement('span', {
    className: classnames(baseClasses('text'), customClasses('lwt-text', classModifiers)),
    'data-test': getDataTestAttribute(props, 'label')
  }, text));
};
LabelWithText.propTypes = {
  label: PropTypes.string.isRequired,
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.object]),
  customClass: PropTypes.string,
  classModifiers: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string), PropTypes.objectOf(PropTypes.bool)]),
  dataTest: PropTypes.string
};
LabelWithText.defaultProps = {
  customClass: 'custom-label-with-text'
};
export default LabelWithText;